var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#fff",
    viewBox: "0 0 256 256"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M181.2 160H170l-4-3.8c14.4-16.7 22.3-38 22.3-60C188.3 45.3 147.1 4 96.2 4S4 45.3 4 96.2s41.3 92.1 92.2 92.2c22 0 43.3-7.9 60-22.3l3.8 4v11.2l70.9 70.8L252 231zm-85 0c-35.2 0-63.8-28.4-63.8-63.6v-.2C32.3 61 60.8 32.4 96 32.3h.2c35.2 0 63.8 28.4 63.8 63.6v.2c0 35.2-28.4 63.8-63.6 63.8-.1.1-.2.1-.2.1"
  })));
};
export default SvgSearch;